<template>
  <div class="my-8 d-flex flex-column gap-2 justify-center">
    <v-icon
      color="success"
      size="80"
      class="mx-auto"
    >
      mdi-check-circle
    </v-icon>
    <div class="text-center mb-1 deleted-text">
      {{ $t('social-media.alert.post-successful-deleted') }}
    </div>
    <v-btn
      variant="text"
      class="close-btn"
      @click="$emit('close')"
    >
      {{ $t('labels.close') }}
    </v-btn>
  </div>
</template>

<style scoped>
.deleted-text {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
}

.close-btn {
  font-size: 14px !important;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
</style>
